import GoogleAnalytics from "./ga";
import YaCounter from "./ym";
import {listener} from "../../../../../../modules/vegas/js/util";

let ym = new YaCounter();

listener('click', '[data-yagoal-click]', function (form) {
	ym.goal(form.dataset.yagoalClick);
});

listener('mouseup', '[data-yagoal-selection]', function (form) {
	if (window.getSelection().toString() !== '') {
		ym.goal(form.dataset.yagoalSelection);
	}
});

listener('show.bs.modal', '[data-yagoal-modalshow]', function (form) {
	ym.goal(form.dataset.yagoalModalshow);
});

listener('vg.fs.success', 'form[data-yagoal-submit]', function (form) {
	ym.goal(form.dataset.yagoalSubmit);
});

/*let ga = new GoogleAnalytics();
listener('click', '[data-gagoal]', function (form) {
	ga.goal(form.dataset['gagoal']);
});
listener('vg.fs.success', 'form[data-form-gagoal]', function (form) {
	ga.goal(form.dataset['formGagoal']);
});*/
